import { Component, OnInit } from "@angular/core";
import { ProgramDetail } from "src/app/models/program";
import { ProgramService } from "src/app/services/program.service";
import { ActivatedRoute } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-detail-program",
  templateUrl: "./detail-program.component.html",
  styleUrls: ["./detail-program.component.css"],
})
export class DetailProgramComponent implements OnInit {
  program: ProgramDetail;
  detailProductList = [];
  productNameList = [];
  productName: string;
  isEmpty: boolean;
  canShowMore: boolean;
  callCenter = [];
  searchProduct = "";
  viewContent: any;
  isLoading = true;

  constructor(
    public programService: ProgramService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.getProgramDetail();
    this.getCallCenter();
  }

  public modifyBorderTableContent(content: string) {
    return content.replace(`<table border="0"`, `<table border="1"`) || content;
  }

  public getProgramDetail() {
    const programId = this.route.snapshot.paramMap.get("id");

    this.program = this.programService.getProgramDetail(
      programId,
      (resp) => {
        this.program = resp;
        this.program.content = this.modifyBorderTableContent(
          resp.content ? resp.content : ""
        );
        this.viewContent = this.sanitizer.bypassSecurityTrustHtml(
          this.program.content
        );

        this.detailProductList = this.program.productProgramJson;
        if (this.detailProductList.length > 10) {
          this.canShowMore = true;

          for (var i = 0; i < this.detailProductList.length; i++) {
            this.productNameList.push(this.detailProductList[i].nameProduct);
          }
        }

        this.isLoading = false;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  public getCallCenter() {
    this.programService.getApplicationOptions(
      (resp) => {
        this.callCenter = resp[0].value;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  public getSearchDetail(search: string) {
    const programId = this.route.snapshot.paramMap.get("id");
    this.productNameList.splice(0, this.productNameList.length);

    this.programService.getSearchProgramDetail(
      programId,
      search,
      (resp) => {
        if (resp.productProgramJson.length != 0) {
          for (var i = 0; i < resp.productProgramJson.length; i++) {
            this.productNameList.push(resp.productProgramJson[i].nameProduct);
          }
        } else {
          this.isEmpty = true;
        }

        this.isLoading = false;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  public onSearchProduct(searchTextValue: string) {
    this.searchProduct = searchTextValue;
    this.isEmpty = false;
    this.getSearchDetail(this.searchProduct);
    this.isLoading = true;
  }

  // public onKeywordChanged() {
  //   this.isEmpty = false;
  //   if (this.productName === "") {
  //     this.searchProduct = "";
  //     this.getSearchDetail(this.searchProduct);
  //   }
  // }
}
